module.exports = __webpack_public_path__ + "static/media/spin-refresh-icon.38df5901.gif";